import { defineComponent, h } from 'vue';
import { QBtn, QIcon, QTooltip } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import BaseComponent from './BaseButtonMixin.jsx';
import '../css/BasicButton.css';

export default defineComponent({
    name: 'popup-menu-button-dsgn',
    mixins: [BaseComponent],
    components: { QBtn, QIcon, QTooltip },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
    },
    methods: {
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
    },
    render() {
        return (
            <div
                class={['q-ma-xs', {
                    'designer-container': true,
                    'c-PopupMenuButton': true,
                    'c-useLiteralCasing': this.useLiteralCasing,
                }]}
                style={this.sizeStyle}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QBtn
                    class={[this.buttonClasses, this.sentenceCaseButtonClasses]}
                    style={this.buttonStyles}
                    color={this.color}
                    align={this.align}
                    fab={this.buttonFab}
                    round={this.buttonFab}
                    flat={this.qBtnFlat}
                    outline={this.qBtnOutline}
                    size={this.size}
                    noCaps
                    dense={this.density}
                    disable={this.isdisabled}
                >
                    {this.getButtonContent()}
                    {this.renderButtonTooltip()}
                </QBtn>
            </div>
        );
    }
});
